import { useQuery } from '@tanstack/react-query'
import { useParseQuery } from '../../../../hooks/useNav'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { adminKeys, PAGE_SIZE } from '../../../../data/queryFactories'
import { database } from '../../../../App'

import { getDataFromMajor } from '../../../../data/entity/user_entity'
import { USER_DATA_COLLECTION, ADMIN_ROLE } from '../../../../data/constants'
import { getListAdmin } from '../../../../service/GetListAdmin'
async function mapAdminData(admins) {
  // const adminData = admins.filter((item) => {
  //   return item.data.groups.includes(ADMIN_ROLE)
  // })
  try {
    const promises = admins.map(async (payload) => {
      const permitedDatePared = payload?.assignDate
        ? new Date(payload.assignDate)
        : null

      const permitedDate = permitedDatePared
        ? permitedDatePared.toLocaleDateString('vi-VN') // định dạng giờ/ngày kiểu VN
        : ''

      const result = await getDataFromMajor(payload.user || {})
      return {
        uuid: payload.user?.uuid || '',
        id: payload.user.schoolId || '',
        name: payload.user?.fullName || '',
        permitedDate: permitedDate || '',
        course: payload.user?.studentCourse || '',
        groups: payload.user?.groups ? payload.user.groups.join(', ') : '',
        email: payload.user?.schoolEmail || '',
        personalEmail: payload.user?.personalEmail || '',
        phoneNumber: payload.user?.phoneNumber || '',
        // class: payload.data?.class || '',
        // faculty: result ? result.faculty : '',
        // school: result ? result.school : '',
        status: payload.user?.status || '',
        // books: payload.data?.books ? payload.data.books : '',
        // devices: payload.data?.devices,
        totalPayment: payload.data?.['total-payment'] || 0,
        major: payload.data?.major || '',
        permitedBy: payload.assigner?.fullName || '',
      }
    })
    return await Promise.all(promises)
  } catch (error) {
    console.error('Error in UserDTO:', error)
    throw error // Ensure the error is thrown to propagate it correctly
  }
}

export default function useGetAdmins() {
  const { queryParams } = useParseQuery() // Placeholder for query params

  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      showLoadingToast('Đang tải', toastKey.SYSTEM.ADMINS.GET)
      // lấy danh sách admin từ fireBase
      // const admins = await database.documents(USER_DATA_COLLECTION)
      const res = await getListAdmin.getAll()
      const admins = res?.data?.data
      const processedAdmins = await mapAdminData(admins)
      showSuccessToast('Tải báo cáo thành công', toastKey.SYSTEM.ADMINS.GET)

      return processedAdmins
    },
    queryKey: adminKeys.list({}),
  })
  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại, vui lòng liên hệ admin',
      loadingToastId: toastKey.ERROR_REPORTS.GET,
    })
  }
  const totalResult = data?.length ?? 0
  const totalPages = Math.ceil(totalResult / PAGE_SIZE)

  return {
    data: {
      admins: data,
      totalResult,
      totalPages,
    },
    isLoading,
  }
}
